import { createSlice } from '@reduxjs/toolkit'
import { Apprentice } from '../../../model/person.model'
import { getPersonFullName } from '../../../util/getPersonName'

const apprenticeSlice = createSlice({
  name: 'apprentices',
  initialState: [] as Apprentice[],
  reducers: {
    allApprenticesSet: (state, action) => {
      return action.payload
    },
    apprenticeAdded: (state, action) => {
      action.payload.full_name = getPersonFullName(action.payload)
      return [...state, action.payload]
    },
    apprenticeUpdated: (state, action) => {
      // Create a new array with the updated apprentice
      return state.map((item) =>
        item.person_id !== action.payload.person_id
          ? item
          : {
              ...item,
              ...action.payload,
              apprentice: action.payload.apprentice,
            }
      )
    },
    apprenticeRemoved: (state, action) => {
      state.filter((apprentice) => apprentice.person_id !== action.payload)
    },
  },
})

export const {
  allApprenticesSet,
  apprenticeAdded,
  apprenticeUpdated,
  apprenticeRemoved,
} = apprenticeSlice.actions

export default apprenticeSlice.reducer